import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import SubstrateHero from "./SubstrateHero";
import DeFiPlatforms from "./DeFiPlatforms";

function Substrate() {
  return (
    <div>
      <Header />
      <SubstrateHero />
      <DeFiPlatforms />
      <Footer />
    </div>
  );
}

export default Substrate;
